import getListItems from '@requests/getListItems.ts';

import I, { LegalListItemT } from '../types.ts';

const getList: I['getList'] = async function () {
    try {
        const { shortList } = await getListItems<{}, { shortList: LegalListItemT[] }>({
            url: 'article',
            query: [
                { key: 'inList', value: 'true' },
                { key: 'type', value: 'legal' },
                { key: 'system', value: 'crm' },
            ],
        });

        this.setState({ shortList: shortList! });
    } catch (error) {}
};

export default getList;
